/*
  Fichier : assets/product-catalog.js - v2
  Gère :
  - la sélection des tailles (texte simple, façon taliri.fr)
  - l'ajout rapide au panier via le bouton "+" (fetch /cart/add.js)
*/

(function () {
  var CART_ADD_URL = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root + 'cart/add.js'
    : '/cart/add.js';

  document.addEventListener('click', function (event) {
    var sizeBtn = event.target.closest('.product-catalog-card__sizes button');
    if (sizeBtn) {
      handleSizeClick(sizeBtn);
      return;
    }

    var addBtn = event.target.closest('[data-add-to-cart]');
    if (addBtn) {
      handleAddToCart(addBtn);
    }
  });

  function handleSizeClick(btn) {
    if (btn.disabled || btn.classList.contains('is-unavailable')) return;

    var card = btn.closest('.product-catalog-card');
    if (!card) return;

    card.querySelectorAll('.product-catalog-card__sizes button').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');

    var input = card.querySelector('[data-selected-variant-id]');
    if (input) input.value = btn.getAttribute('data-variant-id');
  }

  function handleAddToCart(button) {
    if (button.disabled) return;

    var card = button.closest('.product-catalog-card');
    if (!card) return;

    var input = card.querySelector('[data-selected-variant-id]');
    var variantId = input ? input.value : null;
    if (!variantId) return;

    button.disabled = true;

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (result.ok) {
          button.classList.add('is-added');
          button.textContent = '✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result.data }));
          updateCartCount();
        } else {
          button.textContent = '!';
        }
      })
      .catch(function () {
        button.textContent = '!';
      })
      .finally(function () {
        setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-added');
          button.textContent = '+';
        }, 1500);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if (!customElements.get('product-catalog-quick-add')) {
    customElements.define('product-catalog-quick-add', class extends HTMLElement {});
  }
})();